<ng-container *ngFor="let error of errorMessages">
    <small class="p-{{error.severity}} block">
        {{error.message|translate|firstUpper}}
    </small>

</ng-container>
